import { TextSpan } from "components/text-label";
import { Variant } from "features/daily-delivery/types";
import intl from "react-intl-universal";
import { CardTag } from "./styled";

interface TagProps {
  variant: Variant;
}

export const Tag = (props: TagProps) => {
  const variant: Variant = props.variant;

  const getText = (variant?: Variant) => {
    switch (variant) {
      case Variant.Ok:
        return "commons.ok";
      case Variant.FullCapacity:
        return "dailyDelivery.card.fullCapacity";
      case Variant.Critical:
        return "commons.critical";
      default:
        return "commons.ok";
    }
  };

  return (
    <CardTag variant={variant}>
      <TextSpan color="white" display="block" style={{ fontSize: "10px", fontWeight: 500 }}>
        {intl.get(getText(variant))}
      </TextSpan>
    </CardTag>
  );
};
